import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'questionnaire':
        return 'MessageSquare';
      case 'fitgap':
        return 'GitCompare';
      case 'document':
        return 'FileText';
      case 'approval':
        return 'PenTool';
      case 'engagement':
        return 'Plus';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'questionnaire':
        return 'text-primary bg-primary/10';
      case 'fitgap':
        return 'text-accent bg-accent/10';
      case 'document':
        return 'text-success bg-success/10';
      case 'approval':
        return 'text-warning bg-warning/10';
      case 'engagement':
        return 'text-secondary bg-secondary/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground font-inter">
          Recent Activity
        </h3>
        <button className="text-sm text-primary hover:text-primary/80 nav-transition">
          View All
        </button>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
              <Icon 
                name={getActivityIcon(activity?.type)} 
                size={16} 
                className="text-current"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="text-sm text-foreground">
                  <span className="font-medium">{activity?.user}</span>
                  {' '}
                  <span className="text-muted-foreground">{activity?.action}</span>
                  {' '}
                  <span className="font-medium">{activity?.target}</span>
                </p>
                <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                  {formatTimeAgo(activity?.timestamp)}
                </span>
              </div>
              
              {activity?.description && (
                <p className="text-xs text-muted-foreground mt-1">
                  {activity?.description}
                </p>
              )}
              
              {activity?.engagement && (
                <div className="flex items-center space-x-2 mt-1">
                  <Icon name="Building2" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    {activity?.engagement}
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;